import React, { useRef } from "react";
import Teaser from "../Teaser";
import ReactPaginate from 'react-paginate';

const ResultList = (props) => {
	const {
		teasers = [],
		teasersPerPage = -1, // pass -1 to disable pagination
		currentPage = 0,
		onPageChange,
		labelReadMore = "Weiterlesen",
		labelResultCountSingular = "Eintrag",
		labelResultCountPlural = "Einträge",
		labelPrevious = "Zurück",
		labelNext = "Weiter",
		ariaLabelPage = "Seite",
	} = props;

	const listRef = useRef(null);
	
	const ariaLabelBuilder = (i) => ariaLabelPage + " " + i;
	
	const pageCount = Math.ceil(teasers.length / teasersPerPage);
	const offsetStart = currentPage * teasersPerPage;
	const offsetEnd = (currentPage * teasersPerPage) + teasersPerPage;
	const items = (-1 === teasersPerPage) ? teasers.slice() : teasers.slice(offsetStart, offsetEnd);

	return (
		<div className="react-teaserlist-result-list" ref={ listRef }>
			<div className="result-counter" role="status">
				{ teasers.length + " " + ((teasers.length === 1) ? labelResultCountSingular : labelResultCountPlural) }
			</div>
			{ teasersPerPage !== -1 && pageCount > 1 &&
			<ReactPaginate
				previousLabel={ labelPrevious }
				nextLabel={ labelNext }
				breakLabel={ '...' }
				breakClassName={ 'break-me' }
				pageCount={ pageCount }
				marginPagesDisplayed={ 0 }
				pageRangeDisplayed={ 5 }
				forcePage={ currentPage }
				onPageChange={ onPageChange }
				ariaLabelBuilder={ ariaLabelBuilder }
				containerClassName={ 'pagination' }
				activeClassName={ 'active' }
			/>
			}
			<div className="react-teaserlist-results">
				{ items.map(teaser =>
					<Teaser
						key={ teaser.guid }
						dateFrom={ teaser.dateFrom }
						dateTo={ teaser.dateTo }
						category={ teaser.category }
						location={ teaser.location }
						headline={ teaser.headline }
						text={ teaser.text }
						url={ teaser.url }
						labelReadMore={ labelReadMore }
					/>
				) }
			</div>
			{ teasersPerPage !== -1 && pageCount > 1 &&
				<ReactPaginate
					previousLabel={ labelPrevious }
					nextLabel={ labelNext }
					breakLabel={ '...' }
					breakClassName={ 'break-me' }
					pageCount={ pageCount }
					marginPagesDisplayed={ 0 }
					pageRangeDisplayed={ 5 }
					forcePage={ currentPage }
					onPageChange={ newPage => {
						listRef.current.scrollIntoView(); onPageChange(newPage);
					} }
					ariaLabelBuilder={ ariaLabelBuilder }
					containerClassName={ 'pagination' }
					activeClassName={ 'active' }
				/>
			}
		</div>
	);
};

export default ResultList;
